<table mat-table matSort [dataSource]="dataSource" class="w-full">
  <ng-container
    *ngFor="let matDef of matDefs; let i = index"
    matColumnDef="{{ matDef }}"
  >
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      {{ headerDef[i] }}
    </th>
    <td mat-cell *matCellDef="let x">
      <span class="mobile-label">{{ headerDef[i] }}</span>
      <span *ngIf="headerDef[i] == 'ID'" class="text-md">
        <!-- <a class="text-blue-500 hover:text-blue-400" href="{{urlId}}{{x[matDef]}}"> -->
        <!-- comenté el link porque redirigía a inicio-->
        <!-- <a
          class="text-blue-700 hover:underline"
          href="{{ urlId }}{{ x['id'] }}"

        > -->
        {{ x[matDef] }}
        <!-- </a> -->
      </span>
      <span
        *ngIf="
          headerDef[i] != 'ID' &&
          headerDef[i] != 'Adjunto' &&
          headerDef[i] != 'Acciones'
        "
        class="text-md"
      >
        {{ x[matDef] != null ? checkType(x[matDef]) : "--" }}
      </span>
      <!--  -->
      <span *ngIf="headerDef[i] == 'Adjunto'" class="text-md">
        <!-- esto estaba antes en la clase text-blue-500 hover:text-blue-400 lo dejo porlas-->
        <a
          class="text-blue-700 hover:underline"
          href="{{ urlUploads }}{{ x['adjunto'] }}"
          target="_blank"
        >
          {{ x[matDef] }}
        </a>
      </span>
      <span *ngIf="headerDef[i] == 'Acciones'" class="text-md">
        <button
          *ngIf="permisos.p_update"
          mat-icon-button
          matTooltip="Editar"
          (click)="editar(x, update)"
          #update
        >
          <mat-icon class="text-yellow-500">edit</mat-icon>
        </button>
        <button
          *ngIf="permisos.p_delete && x.activo"
          color="warn"
          mat-icon-button
          matTooltip="Desactivar"
          (click)="changeStatus(x, service, serviceName)"
        >
          <mat-icon>delete_forever</mat-icon>
        </button>
        <button
          *ngIf="permisos.p_delete && !x.activo"
          color="success"
          mat-icon-button
          matTooltip="Reactivar"
          (click)="changeStatus(x, service, serviceName)"
        >
          <mat-icon>check</mat-icon>
        </button>
        <button
          *ngIf="permisos.p_especial2"
          mat-icon-button
          matTooltip="Registro"
          type="button"
          (click)="ViewLog(x)"
        >
          <mat-icon class="text-blue-800 dark:text-blue-200">history</mat-icon>
        </button>
      </span>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="matHeaderRowDefs; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: matHeaderRowDefs"></tr>
</table>
